import React from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import SocialMediaButton from "@/components/SocialMediaButton";

type Props = {
  onFacebookPress: () => void;
  onTwitterPress: () => void;
  onInstagramPress: () => void;
  onMessengerPress: () => void;
};

const SocialShareBar: React.FC<Props> = ({
  onFacebookPress,
  onTwitterPress,
  onInstagramPress,
  onMessengerPress,
}) => {
  return (
    <View style={styles.container}>
      <SocialMediaButton platform="facebook" onPress={onFacebookPress} />
      <SocialMediaButton platform="twitter" onPress={onTwitterPress} />
      <SocialMediaButton platform="instagram" onPress={onInstagramPress} />
      <SocialMediaButton platform="messenger" onPress={onMessengerPress} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 24,
    marginBottom: 16,
  },
});

export default SocialShareBar;